import React from "react";
import { Link } from "react-router-dom";
import { Copy } from "lucide-react";
import AnimatedNumber from "./AnimatedNumber";

export default function DuplicatesPanel({ count, value, format, onExport, onPrepareEbay, onViewDuplicates }) {
  return (
    <section data-testid="dashboard-duplicates" className="border border-white/10 bg-[#111113] rounded-2xl p-5 sm:p-6">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2 mb-1">
        <Copy className="w-4 h-4 text-[#A78BFA]" /> Duplicate Cards
      </h2>
      {count > 0 ? (
        <>
          <div className="flex items-end gap-8 mt-3 mb-1">
            <div>
              <AnimatedNumber value={count} className="text-2xl font-display font-bold text-white" testId="duplicates-count" />
              <p className="text-xs text-zinc-500">spare copies</p>
            </div>
            <div>
              <AnimatedNumber value={value} format={format} className="text-2xl font-display font-bold text-[#A78BFA]" testId="duplicates-value" />
              <p className="text-xs text-zinc-500">estimated market value</p>
            </div>
          </div>
          <p className="text-[10px] text-zinc-600 mb-4">Based on recent completed sales.</p>
          <div className="flex flex-wrap items-center gap-2">
            <button
              data-testid="duplicates-prepare-ebay-button"
              onClick={onPrepareEbay}
              className="text-xs font-semibold px-4 py-2 rounded-full bg-[#7C3AED] hover:bg-[#6D28D9] text-white transition-colors"
            >
              Prepare for eBay
            </button>
            <Link
              to="/community"
              data-testid="duplicates-trade-button"
              className="text-xs font-medium px-4 py-2 rounded-full border border-white/15 text-zinc-300 hover:bg-white/5 hover:text-white transition-colors"
            >
              Trade
            </Link>
            <button
              data-testid="duplicates-export-button"
              onClick={onExport}
              className="text-xs font-medium px-4 py-2 rounded-full border border-white/15 text-zinc-300 hover:bg-white/5 hover:text-white transition-colors"
            >
              Export
            </button>
            <button
              data-testid="duplicates-view-button"
              onClick={onViewDuplicates}
              className="text-xs text-[#A78BFA] hover:underline underline-offset-2 ml-1"
            >
              View duplicates →
            </button>
          </div>
        </>
      ) : (
        <p data-testid="duplicates-empty-state" className="text-sm text-zinc-500 mt-3">
          No duplicates? Great! Every card in your collection is unique.
        </p>
      )}
    </section>
  );
}
